import { render, staticRenderFns } from "./SkeletonDetail.vue?vue&type=template&id=ae567322"
import script from "./SkeletonDetail.vue?vue&type=script&lang=js"
export * from "./SkeletonDetail.vue?vue&type=script&lang=js"
import style0 from "./SkeletonDetail.vue?vue&type=style&index=0&id=ae567322&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports